<template>
  <b-modal
    id="user-modal"
    :hide-footer="true"
    @hidden="resetModal"
  >
    <template v-slot:modal-title>
      {{ modalName }}
    </template>

    <b-form @submit.stop.prevent="onSubmit">
      <b-form-group
        id="input-group-fname"
        label="First Name"
        label-for="input-fname"
      >
        <b-input
          id="input-fname"
          v-model="$v.form.fname.$model"
          :state="validateState('fname')"
          aria-describedby="input-fname-live-feedback"
          type="text"
        />
        <b-form-invalid-feedback id="input-fname-live-feedback">
          First name is required
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        id="input-group-lname"
        label="Last Name"
        label-for="input-lname"
      >
        <b-input
          id="input-lname"
          v-model="$v.form.lname.$model"
          :state="validateState('lname')"
          aria-describedby="input-lname-live-feedback"
          type="text"
        />
        <b-form-invalid-feedback id="input-lname-live-feedback">
          Last name is required
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        id="input-group-email"
        label="Email"
        label-for="input-email"
      >
        <b-input
          id="input-email"
          v-model="$v.form.email.$model"
          :state="validateState('email')"
          aria-describedby="input-email-live-feedback"
          type="email"
        />
        <b-form-invalid-feedback id="input-email-live-feedback">
          Please enter a valid email address
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        id="input-group-position"
        label="Position"
        label-for="input-position"
      >
        <b-input
          id="input-position"
          v-model="form.position"
          type="text"
        />
      </b-form-group>
      <b-form-group
        id="input-group-role"
        label="Permissions"
        label-for="input-role"
      >
        <b-form-tags
          v-model="$v.form.roles.$model"
          placeholder="Enter role..."
          :state="validateState('roles')"
          aria-describedby="input-roles-live-feedback"
        />
        <b-form-invalid-feedback id="input-email-live-feedback">
          Please choose a role
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-checkbox
        v-model="form.hidden"
        size="md"
        class="flex-shrink-0 pt-2"
        value="true"
        unchecked-value="false"
      >
        Enabled?
      </b-form-checkbox>
      <div class="d-flex justify-content-end mt-2">
        <b-button
          type="submit"
          variant="primary"
        >
          Save
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

export default {
  name: "UserModal",
  mixins: [validationMixin],
  data() {
    return {
      form: {
        fname: "",
        lname: "",
        position: "",
        roles: [],
        hidden: false
      },
      show: true,
      modalName: "New User"
    };
  },
  validations: {
    form: {
      fname: {
        required
      },
      lname: {
        required
      },
      email: {
        required,
        email
      },
      roles: {
        required
      }
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      } else {
        this.$bvModal.hide("user-modal")
      }
    },
    resetModal(){
        this.form.fname = ''
        this.form.lname = ''
        this.form.email = ''
        this.form.position = ''
        this.form.roles = []
        this.$v.$reset();
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
